const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/+$/, '');
const wsUrl = (import.meta.env.VITE_WS_URL ?? apiBaseUrl).replace(/\/+$/, '');
const isCapacitorBuild = import.meta.env.CAPACITOR_BUILD === 'true';

function requireAbsoluteUrl(value: string, key: string): string {
  if (!isCapacitorBuild) return value;
  try {
    const parsed = new URL(value);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return value;
    }
  } catch {
    // Fall through to the build-time error below.
  }
  throw new Error(`${key} debe ser una URL absoluta http(s) para builds Capacitor`);
}

export const env = {
  VITE_API_BASE_URL: requireAbsoluteUrl(apiBaseUrl, 'VITE_API_BASE_URL'),
  VITE_WS_URL: requireAbsoluteUrl(wsUrl, 'VITE_WS_URL'),
  VITE_APP_NAME: import.meta.env.VITE_APP_NAME ?? 'Compliance Engine',
  CAPACITOR_BUILD: isCapacitorBuild,
};
